import * as mutations from './mutations'
import * as queries from './queries'

export const Company = {
  mutations: {
    ...mutations
  },
  queries: {
    ...queries
  }
}
